import { QueryClient, useMutation, useQuery } from '@tanstack/react-query'

import useAbsenceRequestService from './useAbsenceRequestService'

export const useGetAbsenceRequestListQuery = () => {
  return useQuery({
    queryKey: ['absence-request'],
    queryFn: useAbsenceRequestService.getList,
  })
}

export const useGetAbsenceRequestQuery = (absenceRequestUuid: string) => {
  return useQuery({
    queryKey: ['absence-request', absenceRequestUuid],
    queryFn: ({ queryKey }) =>
      useAbsenceRequestService.getAbsenceRequest(queryKey[1]),
  })
}

export const usePostAbsenceRequestMutation = (queryClient: QueryClient) => {
  return useMutation({
    mutationFn: useAbsenceRequestService.createAbsenceRequest,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['absence-request'] })
    },
  })
}

export const usePutAbsenceRequestMutation = (queryClient: QueryClient) => {
  return useMutation({
    mutationFn: useAbsenceRequestService.updateAbsenceRequest,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['absence-request'] })
    },
  })
}
